<mat-list>
    <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree-content">
        <mat-nested-tree-node *matTreeNodeDef="let nestedNode; when: viewNode">
          <li (click)="clickNode(nestedNode);$event.stopPropagation()">
            <div class="mat-tree-node selectable"
              [class.display-none]="!hasNestedChild(nestedNode)"
              [class.selected]="isSelectedParent(nestedNode)"
              [class.isParent]="!nestedNode.isParent">
              <button mat-icon-button class="toggle-button" matTreeNodeToggle
                [attr.aria-label]="'toggle ' + nestedNode.title">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{nestedTreeControl.isExpanded(nestedNode) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              <div>
                <mat-icon class="editing-icon" *ngIf="isEditingIcon(nestedNode)" mat-list-icon>
                  description
                </mat-icon>
                <mat-icon class="completed-icon" *ngIf="!isEditingIcon(nestedNode)" mat-list-icon>
                  task
                </mat-icon>
              </div>
              <div class="node-label" [matTooltip]="nestedNode.title" matTooltipClass="tooltip-overflow" data-testid="report-nav-item">
                <span>{{nestedNode.title}}</span>
                <p mat-line *ngIf="!nestedNode.isParent" class="version">{{ 'inspectionReportVersion.version' | translate }}: {{nestedNode.version}}</p>
              </div>
            </div>
            <ul [class.tree-invisible]="!nestedTreeControl.isExpanded(nestedNode)">
              <ng-container matTreeNodeOutlet></ng-container>
            </ul>
          </li>
        </mat-nested-tree-node>
      </mat-tree>

    <div *ngIf="!generatedReports || generatedReports.length < 1" fxLayoutAlign="center">
        <p>{{ 'inspectionReportVersion.noReportsVersionFound' | translate }}</p>
    </div>
</mat-list>
